export default __webpack_public_path__ + "static/media/za.441b3517.svg";